import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, Form, FormControl } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { UserService } from 'src/app/services/user.service';
import { Store } from '@ngrx/store';
import * as FormActions from '../../reducers/actions/forms.actions';
import { MatDialog, MatSnackBar } from '@angular/material';
import { PerfilComponent } from '../perfil/perfil.component';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { PagoService } from 'src/app/services/pago.service';
import { Subscription } from 'rxjs';
import { DataTransferService } from 'src/app/services/dataTransfer.service';
import { formatNumber } from '@angular/common';
import { GLOBAL } from 'src/app/services/global';
import { GiroResp } from 'src/types/Giros';


declare const swal: any;

interface AppState {
  form: Form;
}



@Component({
  selector: 'app-pago-derechos',
  templateUrl: './pago-derechos.component.html',
  styleUrls: ['./pago-derechos.component.css'],
  providers: [UserService, PagoService, DataTransferService]
})
export class PagoDerechosComponent implements OnInit {
  public footer = GLOBAL.footer;
  public web = GLOBAL.web;
  public webUrl = GLOBAL.webUrl;

  @ViewChild('openModalPago') openModalPago: TemplateRef<any>;
  @ViewChild('ingreso_sol') ingreso_sol: TemplateRef<any>;
  @ViewChild('openModalPago') openModalPagoFinal: TemplateRef<any>;
  @ViewChild('pagoInProcess') pagoInProcess: TemplateRef<any>;
  @ViewChild('buscar_sol') buscar_sol: TemplateRef<any>;
  @ViewChild('mod_solicitante') mod_solicitante: TemplateRef<any>;

  formderecho
  calculo
  fechaNoti = true //bandera
  identity
  token
  buscando = false
  nuevo_sol_derecho = false

  info_derecho
  id_carro
  carro_prueba
  _pagoxml
  dirs
  info_rut
  valores_cert_noformat
  derecho_buscado = false

  info_mod

  //forms
  public rut = new FormControl('');
  public rol = new FormControl('');
  public dir = new FormControl('');
  public num = new FormControl('');
  public correo = new FormControl('');
  public nombre = new FormControl('');
  public telefono = new FormControl('');
  public url_fracaso = new FormControl('');
  public url_exito = new FormControl('');
  public urlPagoPortal = new FormControl('');

  solicitante
  folio
  registro_sol: FormGroup;
  mod_sol_form: FormGroup;
  buscar_sol_form: FormGroup;
  rut_encontrado
  continuar = false
  solicitud
  btnDisabled = true
  rut_propietario
  public departamento = ""

  public pago_portal: Subscription;
  public pago_finalizado: Subscription;
  public pago_desconectar: Subscription;
  public pago_nuevonumero: Subscription;

  public pagado = false
  public pendientePago = false
  public montoPago
  rutpaga: FormGroup;

  constructor(private _fb: FormBuilder, private rutValidator: RutValidator, private userService: UserService, private spinner: NgxSpinnerService, private store: Store<AppState>, private dialog: MatDialog, private _snackBar: MatSnackBar
    , private _pagoService: PagoService, private _formBuilder: FormBuilder, private _dataService: DataTransferService) {

    this.calculo = ""
    this.buscando = false

    this.rutpaga = this._fb.group({
      rut: ["", [Validators.required, this.rutValidator]]
    })


    this.formderecho = this._fb.group({
      rut: ["", [Validators.required, this.rutValidator]],
      tipoTramite: ["", Validators.required],
      expediente: [""],
      solicitud: [""]
    })

    this.buscar_sol_form = this._fb.group({
      rut: ["", [Validators.required, this.rutValidator]],
    })
  }

  ngOnInit() {

    /* Datos que vienen desde seguimiento */
    var dataService = JSON.parse(localStorage.getItem("dataTransferP"))
    console.log("dataService", dataService)

    if (dataService) {
      this.buscando = true
      if (dataService.depto == "EDIFICACIÓN") {
        this.formderecho.controls.expediente.setValue(dataService.num) //expediente
      }
      if (dataService.depto == "URBANIZACION" || dataService.depto == "RECEPCIONES") {
        this.formderecho.controls.solicitud.setValue(dataService.num)  //Solicitud
      }
      this.formderecho.controls.rut.setValue(dataService.rut)
      this.rutpaga.controls.rut.setValue(dataService.prop.rutProp)
      console.log(this.formderecho.value, this.rutpaga.controls.rut)
      localStorage.removeItem("dataTransferP")
      this.buscar_derecho()
    }


    this.identity = this.userService.getIdentity();
    this.token = this.userService.getToken();

    this.registro_sol = this._formBuilder.group({
      rut: [{ value: '', disabled: true }, [Validators.required, this.rutValidator],],
      nombre: ['', [Validators.required]],
      app: ['', Validators.required],
      apm: ['', Validators.required],
      dir: ['', Validators.required],
      num: ['', [Validators.required, Validators.pattern("[0-9]+")]],
      dircom: [''],
      telefono: ['', Validators.pattern("[0-9]+")],
      celular: ['', [Validators.required, Validators.pattern("[0-9]+")]],
      ciudad: ['', Validators.required],
      comuna: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]]
    })

    this.mod_sol_form = this._formBuilder.group({
      rut: [{ value: '', disabled: true }, Validators.required],
      nombre: ['', [Validators.required]],
      app: ['', Validators.required],
      apm: ['', Validators.required],
      dir: ['', Validators.required],
      num: ['', [Validators.required, Validators.pattern("[0-9]+")]],
      dircom: [''],
      telefono: ['', Validators.pattern("[0-9]+")],
      celular: ['', [Validators.required, Validators.pattern("[0-9]+")]],
      ciudad: ['', Validators.required],
      comuna: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]]
    })
  }

  buscar_derecho() {
    this.onActivate()
    console.log("Buscando derecho")
    this.spinner.show()
    this.pagado = false
    this.pendientePago = false

    this.userService.get_calculo_derecho(this.formderecho.controls.rut.value, this.formderecho.controls.expediente.value, this.formderecho.controls.solicitud.value).subscribe(resp => {
      this.buscando = false
      this.buscar_sol_form.controls.rut.setValue("")
      console.log("Respuesta server", resp)
      if (resp.status == "error") {
        this.spinner.hide()
        swal({
          type: 'warning',
          title: 'Atención!',
          text: "No se encontraron derechos",
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 3500
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });
      } else {
        this.calculo = resp.derecho
        console.log(this.calculo)
        this.solicitud = this.calculo.data[0].fieldData._Tex_ID_Solicitud
        // if (this.calculo.data[0].portalData.Giros_Sol[0] && this.calculo.data[0].portalData.Giros_Sol[0]["Giros_Sol::Giro_RUT"]) {
        console.log(this.calculo)
        if (this.calculo.data[0].fieldData.TRA_CD_GIM_Fecha || this.calculo.data[0].fieldData.TRA_CD_GIM_Nro || this.calculo.data[0].fieldData.TRAEX_Giro_Cod_Calculo) {
          console.log("Ya esta pagado", this.calculo.data[0].fieldData.TRA_CD_GIM_Fecha, this.calculo.data[0].fieldData.TRA_CD_GIM_Nro, this.calculo.data[0].fieldData.TRAEX_Giro_Cod_Calculo)
          this.pagado = true
        } else if (resp.mongoPago != null) {
          if (resp.mongoPago.estado == "Pagado") {
            this.pendientePago = true
          }
        }

        if (this.calculo.data[0].fieldData.Tco_Acta_6_Cal_Notifica_Pago) {
          this.fechaNoti = true
          this.montoPago = formatNumber(Math.round(this.calculo.data[0].fieldData.TRA_CD_TOTAL_PAGAR), 'cl')
          console.log(this.montoPago)
        } else { this.fechaNoti = false }
        console.log(this.calculo)
        this.dialog.closeAll()
        this.nuevo_sol_derecho = false
        this.buscando = true
        this.spinner.hide()

        // } else {
        //   this.dialog.open(this.buscar_sol, { disableClose: true, width: "400px" })
        //   this.spinner.hide()
        // }
      }

    }, error => {
      this.buscar_sol_form.controls.rut.setValue("")
      console.log(error)
    })
  }


  logout() {
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    sessionStorage.removeItem("identity-domCloud");
    sessionStorage.removeItem("token-domCloud");
    this._snackBar.open("Se ha cerrado sesión", "Cerrar", {
      duration: 3000,
    });


  }


  async onSubmit() {
    this.onActivate()
    console.log("entre en ell onsubmit")
    this.spinner.show()

    this.departamento = this.calculo.data[0].fieldData['Tramites 5::TRAEXP_Dpto']

    this.userService.consultar_rut_propietario(this.rutpaga.controls.rut.value, this.calculo.data[0].fieldData._Tex_ID_Solicitud).subscribe(resp => {
      console.log("rut propietario", resp)

      if (resp.status == "ok") {
        this.rut_propietario = resp.respuesta
        var now = moment(new Date()).format("DD-MM-YYYY")
        var pago;
        var valorDerecho = this.calculo.data[0].fieldData.TRA_CD_TOTAL_PAGAR
        console.log(this.calculo.data[0].portalData)
        console.log(this.calculo.data[0].fieldData)
        this.id_carro = this.docId();
        var nombreCompleto = resp.respuesta.data[0].fieldData.Sol_Nom_Sol_Emp
        var dircompleta = resp.respuesta.data[0].fieldData.Sol_Direc_Calle + "N " + resp.respuesta.data[0].fieldData.Sol_Direc_Num
        if (nombreCompleto.length > 45) {
          nombreCompleto = nombreCompleto.substring(0, 45)
        }

        if (dircompleta.length > 45) {
          dircompleta = dircompleta.substring(0, 45)
        }

        now = now.replace(/\-/g, "")
        var dv = resp.respuesta.data[0].fieldData.Sol_DV
        if (this.calculo.data[0].fieldData.Sol_DV == "k") {
          dv = (this.calculo.data[0].fieldData.Sol_DV).toString().toUpperCase()
        }

        console.log("fecha hoy ", now)

        this.carro_prueba = `<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:ser="http://proexsi.cl/servicios/ServicioLCGDR/">
          <soapenv:Header/>
          <soapenv:Body>
             <ser:ConsultaFolioInternet>
                <!--Optional:-->
                <ser:request>
                   <!--Optional:-->
                   <ser:ACCION></ser:ACCION>
                   <!--Optional:-->
                   <ser:COD_SIS>CO</ser:COD_SIS>
                   <!--Optional:-->
                   <ser:EXISTE></ser:EXISTE>
                   <ser:FECPAG>0</ser:FECPAG>
                   <ser:FOLTRAN>0</ser:FOLTRAN>
                   <!--Optional:-->
                   <ser:CD_ISPEC_INI00>
                      <!--Optional:-->
                      <ser:INSTIT>LC</ser:INSTIT>
                      <!--Optional:-->
                      <ser:CODUSU>SOLNET</ser:CODUSU>
                      <!--Optional:-->
                      <ser:PASUSU>SOLNET</ser:PASUSU>
                   </ser:CD_ISPEC_INI00>
                </ser:request>
             </ser:ConsultaFolioInternet>
          </soapenv:Body>
       </soapenv:Envelope>`


        console.log(this.carro_prueba)

        //girar con lo nuevo Aqui, reemplazar sockets. Actualizar fecha pago y gim.

        this._pagoService.generateGiroExpediente(this.id_carro, this.carro_prueba, this.calculo, resp.respuesta, valorDerecho, this.departamento).subscribe({
          next: (resp: GiroResp) => {
            if(resp.success && resp.paymentLink) {
              this.dialog.open(this.pagoInProcess, {disableClose: true, width: '400px', height: 'auto' })
              window.open(resp.paymentLink, '_blank')
            } else {
              alert("No se pudo obtener el enlace de pago. Intente nuevamente")
            }
          },
          error: (error) => {
            this.spinner.hide()
            this.btnDisabled = false
            alert("Ha ocurrido un error al generar la intención de pago, intente nuevamente")
            console.log("error to generate giro",error)
          },
          complete: () => {
            this.btnDisabled = false
            this.spinner.hide()
        }
        })



        //SOCKET.IO
/*         this.pago_portal = this._pagoService.pago_portal.subscribe(
          pago => {

            console.log("Estado antes del pago", pago.mensaje)
            this.urlPagoPortal = pago.url


            if (pago.portal) {
              console.log('entre en el pago portal')
              this.spinner.hide()
              this.dialog.open(this.pagoInProcess, { disableClose: true, width: '400px', height: 'auto' })

              setTimeout(() => {
                $('#pasa').submit();
                this.btnDisabled = false
              }, 5000);
            }


          },
          error => {
            console.log(error)
          }
        )


        this.pago_nuevonumero = this._pagoService.pago_nuevonumero.subscribe(
          response => {
            console.log("pago nuevo numero")
            if (response.nuevo_numero) {
              this.id_carro = this.docId();
              this._pagoService.newPagoDerecho(this.id_carro, this.carro_prueba, this.calculo, resp.respuesta, valorDerecho, this.departamento);
            }

          },
          error => {
            console.log(error)
          }) */

      } else {
        this.spinner.hide()
        swal({
          type: 'warning',
          title: 'Atención!',
          text: "No se encontró el rut en los propietarios de este derecho",
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 5000
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });
      }

    }, error => {
      console.log(error)
    })

    // this.pago_desconectar = this._pagoService.disconnect.subscribe(
    //     response => {
    //         console.log(response)
    //     },
    //     error => {
    //         console.log(error)
    //     }
    // )


  }


  openPerfil() {
    this.dialog.open(PerfilComponent)
  }

  private docId() {
    let text = '';
    const possible = '0123456789';

    for (let i = 0; i < 8; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
  }


  volver() {
    this.buscando = false
    this.formderecho.controls.rut.value = ""
    this.formderecho.controls.expediente.value = ""
    this.formderecho.controls.solicitud.value = ""
    this.pagado = false
    this.pendientePago = false
    this.nuevo_sol_derecho = false
    this.rutpaga.value("")
  }

  closeTab() {
    window.close();
  }

  registrar_sol() {
    this.onActivate()
    this.spinner.show()

    var userinfo = {
      rut: this.registro_sol.controls.rut.value,
      nombre: this.registro_sol.controls.nombre.value,
      app: this.registro_sol.controls.app.value,
      apm: this.registro_sol.controls.apm.value,
      dir: this.registro_sol.controls.dir.value,
      num: this.registro_sol.controls.num.value,
      dircom: this.registro_sol.controls.dircom.value,
      telefono: this.registro_sol.controls.telefono.value,
      celular: this.registro_sol.controls.celular.value,
      ciudad: this.registro_sol.controls.ciudad.value,
      comuna: this.registro_sol.controls.comuna.value,
      email: this.registro_sol.controls.email.value,
    }

    this.userService.save_solicitante(userinfo).subscribe(response => {

      this.spinner.hide()
      swal({
        type: 'success',
        title: 'Registrado!',
        text: response.message,
        confirmButtonColor: '#3F51B5',
        confirmButtonText: 'Aceptar',
        timer: 3500,
        onClose: () => {
          this.spinner.show()
          this.userService.insertar_calculo(userinfo.rut, this.solicitud).subscribe(resp => {
            if (resp.code == "200") {
              this.buscar_derecho()

            } else {
              swal({
                type: 'warning',
                title: 'Atención!',
                text: "Ha ocurrido un error",
                confirmButtonColor: '#3F51B5',
                confirmButtonText: 'Aceptar',
                timer: 3500
              }).then(() => {
              }, (dismiss) => {
                if (dismiss === 'timer') {
                }
              });
            }

          }, error => {
            console.log(error)
          })
        }
      }).then(() => {
      }, (dismiss) => {
        this.spinner.show()
        this.userService.insertar_calculo(userinfo.rut, this.solicitud).subscribe(resp => {
          if (resp.code == "200") {
            this.buscar_derecho()

          } else {
            swal({
              type: 'warning',
              title: 'Atención!',
              text: "Ha ocurrido un error",
              confirmButtonColor: '#3F51B5',
              confirmButtonText: 'Aceptar',
              timer: 3500
            }).then(() => {
            }, (dismiss) => {
              if (dismiss === 'timer') {
              }
            });
          }

        }, error => {
          console.log(error)
        })

        if (dismiss === 'timer') {
        }
      });
    }, error => {
      console.log(error)
    })
  }

  buscar_solicitante() {
    this.onActivate()
    this.spinner.show()

    var rutSinPuntos = this.buscar_sol_form.controls.rut.value
    if (this.buscar_sol_form.controls.rut.value.toString().includes(".")) {
      rutSinPuntos = this.buscar_sol_form.controls.rut.value.toString().replace(".", "")
      if (rutSinPuntos.includes(".")) {
        rutSinPuntos = rutSinPuntos.replace(".", "")
      }
      console.log("entre en el if de los puntos", rutSinPuntos)
    }

    this.userService.traerInfo_rut(rutSinPuntos).subscribe(
      response => {
        this.rut_encontrado = false
        if (response) {
          this.dialog.closeAll()
          this.info_rut = response
          console.log(this.info_rut)
          // this.primerPaso = true
          this.rut_encontrado = true

          var email = this.info_rut.email
          email.replace(" ", "")

          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          console.log("verificacion del mail", re.test(String(email).toLowerCase()))
          if (re.test(String(email).toLowerCase())) {

            if (this.nuevo_sol_derecho) {

              this.userService.actualizar_calculo(this.info_rut.rut, this.solicitud).subscribe(resp => {
                console.log(resp)
                if (resp.code == "200") {

                  this.buscar_derecho()
                  // this.dialog.closeAll()
                  // this.buscando = true
                } else {
                  this.spinner.hide()
                  swal({
                    type: 'warning',
                    title: 'Atención!',
                    text: "Ha ocurrido un error",
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                  }).then(() => {
                  }, (dismiss) => {
                    if (dismiss === 'timer') {
                    }
                  });
                }
              }, error => {
                console.log(error)
              })

            } else {
              this.userService.insertar_calculo(this.info_rut.rut, this.solicitud).subscribe(resp => {
                if (resp.code == "200") {

                  this.buscar_derecho()
                  // this.dialog.closeAll()
                  // this.buscando = true
                } else {
                  this.spinner.hide()
                  swal({
                    type: 'warning',
                    title: 'Atención!',
                    text: "Ha ocurrido un error",
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                  }).then(() => {
                  }, (dismiss) => {
                    if (dismiss === 'timer') {
                    }
                  });
                }
              }, error => {
                console.log(error)
              })
            }


          } else {
            this.spinner.hide()
            swal({
              type: 'warning',
              title: 'Atención!',
              text: "Email no valido, debe modificar los datos.",
              confirmButtonColor: '#3F51B5',
              confirmButtonText: 'Aceptar',
              timer: 3500,
              onClose: () => {
                this.buscar_info_sol()
              }
            }).then(() => {
            }, (dismiss) => {
              if (dismiss === 'timer') {
                this.buscar_info_sol()
              }
            });


          }
        }
      }, error => {
        this.dialog.closeAll()
        this.registro_sol.controls.rut.setValue(this.buscar_sol_form.controls.rut.value)

        this.buscar_sol_form.controls.rut.setValue("")
        this.spinner.hide()
        this.dialog.open(this.ingreso_sol, { width: "400px", disableClose: true })
      }
    )
  }

  mod_into_derecho() {
    this.buscar_sol_form.controls.rut.setValue(this.calculo.data[0].portalData.Giros_Sol[0]['Giros_Sol::Giro_RUT'] + this.calculo.data[0].portalData.Giros_Sol[0]['Adm_Solicitantes 23::Sol_DV'])
    this.buscar_info_sol()
  }

  buscar_info_sol() {
    this.spinner.show()
    this.continuar = false
    console.log("buscando rut", this.buscar_sol_form.controls.rut.value)
    var rutSinPuntos = this.buscar_sol_form.controls.rut.value
    if (this.buscar_sol_form.controls.rut.value.toString().includes(".")) {
      rutSinPuntos = this.buscar_sol_form.controls.rut.value.toString().replace(".", "")
      if (rutSinPuntos.includes(".")) {
        rutSinPuntos = rutSinPuntos.replace(".", "")
      }
      console.log("entre en el if de los puntos", rutSinPuntos)
    }

    this.userService.traerInfo_rut(rutSinPuntos).subscribe(
      response => {
        this.rut_encontrado = false
        if (response) {

          this.info_rut = response
          console.log(this.info_rut)
          // this.primerPaso = true
          this.rut_encontrado = true
          this.spinner.hide()

          this.abrir_modal_mod()
        }
        console.log("continuar", this.continuar)
      }, error => {
        this.spinner.hide()
        console.log(error)
        swal({
          type: 'warning',
          title: 'Atención!',
          text: "Ha ocurrido un error",
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 3500
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });
      }
    )
  }

  abrir_modal_mod() {
    this.dialog.closeAll();
    this.nuevo_sol_derecho = false
    this.dialog.open(this.mod_solicitante, { disableClose: true })


    this.mod_sol_form.controls.rut.setValue(this.info_rut.rut)
    this.mod_sol_form.controls.nombre.setValue(this.info_rut.nombre)
    this.mod_sol_form.controls.app.setValue(this.info_rut.apellido_p)
    this.mod_sol_form.controls.apm.setValue(this.info_rut.apellido_m)
    this.mod_sol_form.controls.dir.setValue(this.info_rut.calle)
    this.mod_sol_form.controls.num.setValue(this.info_rut.numero)
    this.mod_sol_form.controls.dircom.setValue(this.info_rut.complemento)
    this.mod_sol_form.controls.telefono.setValue(this.info_rut.telefono)
    this.mod_sol_form.controls.celular.setValue(this.info_rut.celular)
    this.mod_sol_form.controls.ciudad.setValue(this.info_rut.ciudad)
    this.mod_sol_form.controls.comuna.setValue(this.info_rut.comuna)
    this.mod_sol_form.controls.email.setValue(this.info_rut.email)

  }

  mod_sol() {
    this.onActivate()
    this.info_mod = {
      nombre: this.mod_sol_form.controls.nombre.value,
      apellido_p: this.mod_sol_form.controls.app.value,
      apellido_m: this.mod_sol_form.controls.apm.value,
      calle: this.mod_sol_form.controls.dir.value,
      num: this.mod_sol_form.controls.num.value,
      complemento: this.mod_sol_form.controls.dircom.value,
      telefono: this.mod_sol_form.controls.telefono.value,
      cel: this.mod_sol_form.controls.celular.value,
      ciudad: this.mod_sol_form.controls.ciudad.value,
      comuna: this.mod_sol_form.controls.comuna.value,
      email: this.mod_sol_form.controls.email.value,
    }
    this.userService.save_info_mod_solicitante(this.mod_sol_form.controls.rut.value, this.info_mod).subscribe(res => {
      console.log(res)

      swal({
        type: 'success',
        title: 'Guardado!',
        text: res.message,
        confirmButtonColor: '#3F51B5',
        confirmButtonText: 'Aceptar',
        timer: 3500,
        onClose: () => {
          this.spinner.show()
          this.userService.insertar_calculo(this.info_rut.rut, this.solicitud).subscribe(resp => {
            if (resp.code == "200") {
              this.buscar_derecho()

            } else {
              swal({
                type: 'warning',
                title: 'Atención!',
                text: "Ha ocurrido un error",
                confirmButtonColor: '#3F51B5',
                confirmButtonText: 'Aceptar',
                timer: 3500
              }).then(() => {
              }, (dismiss) => {
                if (dismiss === 'timer') {
                }
              });
            }

          }, error => {
            console.log(error)
          })
        }
      }).then(() => {
      }, (dismiss) => {
        this.spinner.show()
        this.userService.insertar_calculo(this.info_rut.rut, this.solicitud).subscribe(resp => {
          if (resp.code == "200") {
            this.buscar_derecho()

          } else {
            console.log(resp)
            swal({
              type: 'warning',
              title: 'Atención!',
              text: "Ha ocurrido un error",
              confirmButtonColor: '#3F51B5',
              confirmButtonText: 'Aceptar',
              timer: 3500
            }).then(() => {
            }, (dismiss) => {
              if (dismiss === 'timer') {
              }
            });
          }

          if (dismiss === 'timer') {
          }
        });
        this.dialog.closeAll()
        this.nuevo_sol_derecho = false
      }, error => {
        swal({
          type: 'error',
          title: 'Ha ocurrido un error!',
          text: error._body,
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 3500
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });
        this.dialog.closeAll()
        this.nuevo_sol_derecho = false
      })
    })
  }

  buscar_nuevo_sol() {
    this.nuevo_sol_derecho = true
    this.dialog.open(this.buscar_sol, { disableClose: true, width: "400px" })
  }

  cerrarDialogs() {

    this.dialog.closeAll()
    this.buscar_sol_form.controls.rut.setValue("")

  }

  onActivate() {
    window.scroll(0, 0);
  }

}


